import dayjsTZ from "../../../../utils/dayjs";
import { store } from "../../../../store";
import { groupSingleShift } from "../../../Pagat/PaySub/employeeCalc/calculcate";
import {
  buildReportResult,
  emptyReportResult,
  employeeFullName,
  intervalBounds,
  round2,
  weekdayKeysInRange,
} from "../reportResult";

function shiftDurationHours(shift) {
  if (!shift) return 8;
  // Common shapes: shiftStart/shiftEnd as "HH:mm", or totalHours
  if (Number.isFinite(Number(shift.totalHours))) {
    return Number(shift.totalHours);
  }
  const start = shift.shiftStartTime || shift.startTime || shift.shiftStart;
  const end = shift.shiftEndTime || shift.endTime || shift.shiftEnd;
  if (start && end) {
    const s = dayjsTZ(start, "HH:mm");
    let e = dayjsTZ(end, "HH:mm");
    if (!e.isAfter(s)) e = e.add(1, "day");
    return Math.max(0, e.diff(s, "hours", true));
  }
  return 8;
}

/**
 * Planned (from assigned shift defs × weekdays) vs actual worked hours.
 */
export const plannedVsActual = (
  _prev,
  filter,
  columns,
  manualColumns,
  employees,
) => {
  if (!filter) return emptyReportResult(columns, manualColumns);

  const data = store?.getState()?.customReducer?.reportClockings || [];
  const shifts =
    store?.getState()?.shiftsList?.shifts ||
    store?.getState()?.shifts?.shifts ||
    [];
  const shiftById = new Map((shifts || []).map((s) => [s.shiftId, s]));
  const { startTs, endTs } = intervalBounds(filter);
  const weekdays = weekdayKeysInRange(startTs, endTs);
  const actualByEmp = new Map();
  for (const d of data) {
    if (!d?.clockInDate || !d?.clockOutDate) continue;
    if (d.clockInDate < startTs || d.clockInDate > endTs) continue;
    if (filter?.employeeId && d.employeeId !== filter.employeeId) continue;
    const {
      NORMAL_HOURS = {},
      LATE_HOURS = {},
      EXTRA_HOURS = {},
    } = groupSingleShift(d) || {};
    const hours =
      (Number(NORMAL_HOURS?.amount) || 0) +
      (Number(LATE_HOURS?.amount) || 0) +
      (Number(EXTRA_HOURS?.amount) || 0);
    actualByEmp.set(
      d.employeeId,
      (actualByEmp.get(d.employeeId) || 0) + hours,
    );
  }

  const active = (employees || []).filter(
    (e) =>
      e?.employeeStatus === "Aktiv" &&
      (!filter?.employeeId || e.employeeId === filter.employeeId),
  );

  const preFilter = active
    .map((emp) => {
      const shiftIds = emp?.employeeShiftId || [];
      const ids = Array.isArray(shiftIds) ? shiftIds : [shiftIds].filter(Boolean);
      const primary = shiftById.get(ids[0]);
      const daily = shiftDurationHours(primary);
      const hireKey = emp?.employeeHireDate
        ? dayjsTZ(emp.employeeHireDate).format("YYYY-MM-DD")
        : null;
      const plannedDays = weekdays.filter(
        (d) => !hireKey || d >= hireKey,
      ).length;
      const plannedHours = round2(plannedDays * daily);
      const actualHours = round2(actualByEmp.get(emp.employeeId) || 0);
      const varianceHours = round2(actualHours - plannedHours);
      const variancePct =
        plannedHours > 0
          ? round2((varianceHours / plannedHours) * 100)
          : 0;
      return {
        ...emp,
        employee: employeeFullName(emp),
        employeeDepartmentName: emp.employeeDepartmentName || "",
        employeeTeam: emp.employeeTeam || "",
        shiftName: primary?.shiftName || primary?.name || "—",
        plannedHours,
        actualHours,
        varianceHours,
        variancePct,
      };
    })
    .sort((a, b) =>
      String(a.employee).localeCompare(String(b.employee), "sq"),
    );

  return buildReportResult(preFilter, columns, manualColumns);
};
